<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {BlogPostLayout, Hero} from '@react-spectrum/docs';
export default BlogPostLayout;

---
description: For our last release of the year, we are pushing Slider out of alpha! This component has been a combined effort from our contributors and the team over the last few months. It features support for mouse, touch, and keyboard in both Slider and RangeSlider as well as a list of other features and options.
date: 2020-12-22
---

# December 22, 2020 Release
For our last release of the year, we are pushing Slider out of alpha! This component has been a combined effort from several external contributors and the core team over the last few months. It features support for mouse, touch, and keyboard in both Slider and RangeSlider as well as many other features and options. You can read about them in our [Slider](https://react-spectrum.adobe.com/react-spectrum/Slider.html), [RangeSlider](https://react-spectrum.adobe.com/react-spectrum/RangeSlider.html) and [useSlider](https://react-spectrum.adobe.com/react-aria/useSlider.html) docs. A special thanks to [@mischnic](https://github.com/mischnic) and [@chungwu](https://github.com/chungwu) for their contributions to this work.

From the whole team, be safe and we will see you next year!

## New component
- **Slider**
  - `@react-spectrum/slider`
  - `@react-aria/slider`
  - `@react-stately/slider`

## Updated
- Update `useBreadcrumbItem` type - [@stefanprobst](https://github.com/stefanprobst) - [PR](https://github.com/adobe/react-spectrum/pull/1317)
- Replace `Slider` prop `valueLabel` with `getValueLabel` function - [@govett](https://github.com/devongovett) - [PR](https://github.com/adobe/react-spectrum/pull/1399)
- Require `numberFormatter` in `useSliderState` - [@snowystinger](https://github.com/snowystinger) - [PR](https://github.com/adobe/react-spectrum/pull/1381)

## Released packages
```
 - @adobe/react-spectrum@3.7.0
 - @react-aria/breadcrumbs@3.1.2
 - @react-aria/slider@3.0.0
 - @react-aria/utils@3.5.0
 - @react-spectrum/slider@3.0.0
 - @react-stately/slider@3.0.0
 - @react-types/breadcrumbs@3.2.0
 - @react-types/slider@3.0.0
 - react-aria@3.3.0
 - react-stately@3.2.0
 ```

